// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { currentShippingAddressStyles } from "@insite/content-library/Widgets/Addresses/CurrentShippingAddress";
import Edit from "@insite/mobius/Icons/Edit";
import { createLinkIconStyles } from "@tps/XDL/Utilities";
import { css } from "styled-components";

currentShippingAddressStyles.headingGridItem = {
    width: 12,
};

currentShippingAddressStyles.useBillingAddress = {
    button: {
        variant: "secondary",
        css: css`
            margin-top: 20px;
        `,
    },
};

currentShippingAddressStyles.editLink = {
    ...createLinkIconStyles(Edit, {
        css: css`
            margin-left: 30px;
            margin-top: 6px;
        `,
    }),
};
